import type { IconData } from '@stacksjs/iconify-core'

export const basicArrowsRightCircle: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.5 8l-4 4v-2h-4V6h4V4z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicArrowsRightCircle
